// Curated company figures. Numeric entries count up on scroll; `text`
// entries (e.g. "24/7") render statically. Confirm real numbers with the
// client before publishing.
export const stats = [
  { to: 6, label: "Countries Served" },
  { to: 47, label: "Counties Covered" },
  { to: 40, suffix: "+", label: "Team Members" },
  { to: 1000, suffix: "+", label: "Customers" },
  { text: "24/7", label: "Support" },
];
